<div>
  <label for="exampleInputEmail1">نمایش Linearity</label>
  <select class="custom-select" [(ngModel)]="selected_Display" (change)="Set_DisplayLinearity()" name="selected_Display" >
    <option value="1">نمایش داده شود</option>
    <option value="0">نمایش داده نشود</option>
  </select>
</div>